import clsx from 'clsx';
import React from 'react';

import { Article } from '../../interfaces/homepage';
import StoryItem from './StoryItem';

interface RelatedStoriesProps {
  articles: Article[];
  className?: string;
}

const RelatedStories = ({ articles, className }: RelatedStoriesProps): JSX.Element => {
  return (
    <aside
      className={clsx('mx-0 border-0 border-t border-solid border-black pt-28', className)}
      data-testid="related-stories"
    >
      <header>
        <h3 className="mb-24 font-suisse-works text-headline-md">Related</h3>
      </header>
      <div className="grid grid-cols-1 gap-36 xs:gap-48 sm:grid-cols-2 md:grid-cols-4">
        {articles.length > 0 &&
          articles.map((article) => <StoryItem key={article.id} {...article} />)}
      </div>
    </aside>
  );
};

export default RelatedStories;
